import makeThemedStyles from '../Theme/makeThemedStyles';

const useInputStyles = makeThemedStyles(theme => ({
  input: {
    paddingBottom: '0.5rem',
  },
}));

export default useInputStyles;
